import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { useEsQueryLogStore } from '@features/admin/es-query-logs/useEsQueryLogStore';
import EsQueryLogPage from '@features/admin/es-query-logs/EsQueryLogPage';

const searchSchema = z.object({
  page: z.coerce.number().optional().default(1),
  size: z.coerce.number().optional().default(20),
  queryType: z.string().optional(),
  requestId: z.string().optional(),
  userId: z.coerce.number().optional(),
  minDurationMs: z.coerce.number().optional(),
  minResponseSize: z.coerce.number().optional(),
  requestHash: z.coerce.number().optional(),
  dateFrom: z.string().optional(),
  dateTo: z.string().optional(),
});

export const Route = createFileRoute('/admin/es-query-logs/')({
  validateSearch: search => searchSchema.parse(search),
  component: RouteComponent,
  beforeLoad: ctx => {
    const { page, size, ...filters } = ctx.search;
    useEsQueryLogStore.getState().loadLogs({
      ...filters,
      page: page || 1,
      size: size || 20,
    });
  },
});

function RouteComponent() {
  return <EsQueryLogPage />;
}
